// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"3c083ee0","240":"49f641ce","285":"e261b5f0","396":"0e48c800","483":"4785c5f4","496":"56449785","762":"bc4a0ac1","830":"b5217b84"}[chunkId] + ".chunk.js";
};